import { experimentalRichEditPolicy, type RichEditSkin, type RichEditVariant } from '@/app/richEdit'

// Programmatic test switch for /nazarov?showpin=123456.
// No msg_type, route, cookie, or persisted model change is involved.
// 'std'       // simple/current rich editor
// 'extended'  // extended rich editor
// 'blocks'    // interact.js layout editor
// 'canvas'    // Fabric canvas editor
// 'contacts'  // pure-data contacts form (rich_data envelope)

export const STD_RICH_EDIT_VARIANT: RichEditVariant = 'extended'
export const RICH_EDIT_POLICY = experimentalRichEditPolicy(STD_RICH_EDIT_VARIANT)

export const stdRichEditSkin: RichEditSkin = {
  root: 'flex min-h-0 flex-1 flex-col gap-2',
  modeBar: 'flex min-h-10 flex-wrap items-center gap-2 border-b border-[#d7dde3] bg-[#f7f9fb] px-2 py-1.5',
  modeButton: 'h-7 cursor-pointer rounded border border-[#c5cdd5] bg-white px-2 text-xs text-[#314253] hover:bg-[#edf2f6]',
  modeButtonActive: 'h-7 cursor-pointer rounded border border-[#3472a9] bg-[#eaf2fa] px-2 text-xs font-semibold text-[#3472a9]',
  toolbar: 'flex flex-wrap items-center gap-2 border-b border-[#d7dde3] bg-white px-2 py-1.5',
  toolbarGroup: 'flex flex-wrap items-center gap-1',
  button: 'flex h-7 min-w-7 items-center justify-center rounded border border-[#c5cdd5] bg-white px-2 text-xs text-[#314253] hover:bg-[#edf2f6] disabled:cursor-not-allowed disabled:opacity-40',
  buttonActive: 'border-[#3472a9] bg-[#eaf2fa] text-[#3472a9]',
  select: 'h-7 rounded border border-[#c5cdd5] bg-white px-2 text-xs text-[#314253]',
  color: 'h-7 w-8 cursor-pointer rounded border border-[#c5cdd5] bg-white p-0.5',
  surfaceWrap: 'min-h-[300px] flex-1',
  surface: 'box-border min-h-[300px] w-full overflow-auto rounded border border-[#c5cdd5] bg-white px-3 py-2 text-[#1f2933] outline-none focus:border-[#3472a9] [&_a]:text-[#2277aa] [&_img]:max-w-full [&_table]:border-collapse [&_td]:min-w-16 [&_td]:p-1',
  status: 'ml-auto text-[11px] text-[#687684]',
  blocks: {
    toolbar: 'flex flex-wrap items-center gap-1 border-b border-[#d7dde3] bg-white px-2 py-1.5',
    stage: 'relative min-h-[320px] overflow-auto rounded border border-[#c5cdd5] bg-[#eef2f5] bg-[linear-gradient(#d9e0e6_1px,transparent_1px),linear-gradient(90deg,#d9e0e6_1px,transparent_1px)] bg-[size:20px_20px]',
    block: 'group absolute box-border cursor-move overflow-hidden rounded border border-[#aab8c5] bg-white shadow-sm',
    blockSelected: 'border-[#3472a9] ring-2 ring-[#3472a9]/20',
    blockContent: 'h-full overflow-auto p-3 text-sm text-[#26323d] outline-none cursor-text',
    handle: 'pointer-events-none absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center bg-[#3472a9] text-[10px] text-white',
    empty: 'flex min-h-[320px] items-center justify-center text-sm text-[#687684]',
  },
  canvas: {
    toolbar: 'flex flex-wrap items-center gap-1 border-b border-[#d7dde3] bg-white px-2 py-1.5',
    stage: 'min-h-[360px] overflow-auto rounded border border-[#c5cdd5] bg-[#e7ebef] p-3',
    viewport: 'mx-auto w-fit overflow-hidden bg-white shadow-sm',
    fallback: 'mx-auto max-w-full bg-white [&_svg]:block [&_svg]:h-auto [&_svg]:max-w-full',
  },
}
